import { module } from 'modujs';
import Swiper from 'swiper';
import {  Navigation, Autoplay } from 'swiper/modules';

export default class extends module {
  constructor(m) {
    super(m);

    this.$el = this.el

    this.$slider = this.$("slider")[0] || this.$el.querySelector('.swiper')
    this.$prev = this.$("prev")[0]
    this.$next = this.$("next")[0]


    // Bind
  }


  init() {

    Swiper.use([Navigation, Autoplay]);

      const options = {
        slidesPerView: 1,
        duration: 1600,
        grabCursor: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: this.$next,
        },
      }

      this.swiper = new Swiper(this.$slider, {

        ...options,
      })
  }


  destroy() {
    super.destroy();
    this.swiper.destroy();
  }
}
